import { applyMiddleware, compose, createStore, } from 'redux';
import thunk from 'redux-thunk';
import { makeRootReducer } from './reducers';
const USER_SESSION_INITIAL_STATE = '__USER_SESSION_INITIAL_STATE__';
/**
 * If no initial state is passed look for global
 * @returns {Object}
 */
function getInitialState() {
    return (typeof window === 'object' && window[USER_SESSION_INITIAL_STATE]) || {};
}
/**
 * Whether or not global store already exists in window.
 * @return {Boolean}
 */
function hasUserSessionStore() {
    return typeof window === 'object' && window.__Z_USER_SESSION_STORE__ !== undefined;
}
/**
 * Whether or not global store already exists in window.
 * @return {Object} global store
 */
function getUserSessionStore() {
    return createUserSessionStore();
}
const DEFAULT_CONFIGURATION = {
    middleware: [],
    enhancers: [],
    reducer: makeRootReducer({}),
    initialState: getInitialState(),
    overrideExisting: false,
};
/**
 * Creates global redux store to be used across react components.
 *
 * Side effect: Stores the redux store on the window. Due to type constraints, the typing of the
 * window stored redux store is assumed to the default types for this function. If you override
 * the state and supported actions by providing your own initialState and reducer, you'll need to
 * cast the global window object
 * @return global store
 */
function createUserSessionStore(config = {}) {
    const { middleware, enhancers, reducer, initialState, overrideExisting } = {
        ...DEFAULT_CONFIGURATION,
        ...config,
    };
    if (!overrideExisting && hasUserSessionStore()) {
        return window.__Z_USER_SESSION_STORE__;
    }
    // modified compose to allow for use of Redux Tools extension
    // https://github.com/zalmoxisus/redux-devtools-extension
    const composeEnhancers = (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;
    const store = createStore(reducer, initialState, composeEnhancers(applyMiddleware(...[thunk, ...middleware]), ...enhancers));
    window.__Z_USER_SESSION_STORE__ = store;
    return window.__Z_USER_SESSION_STORE__;
}
export { DEFAULT_UI_CONFIG } from './reducers/regLogin';
export { USER_SESSION_INITIAL_STATE, createUserSessionStore, hasUserSessionStore, getUserSessionStore };
